import src from "IMAGE";
export default { src, width: 800, height: 600, blurWidth: 8, blurHeight: 6, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAANUlEQVR42pXOMQoAIAwDwFYRQWff4dL/v60ZMrbQBm4LJCKNKEzSqHDg0c4KHwxuNrFolI85SAgAySLxxOEAAAAASUVORK5CYII="};
